<template>
  <div class="col-lg-4 col-md-12 col-sm-12 col-xl-3">
    <div class="card" style="padding:10px;"  v-show="currentUserType=='enterprise'">
      <div style="line-height:30px;color:#333;">
        <div style="display: inline-block;float:left;">简历分类</div>
        <div style="display: inline-block;float:right;cursor: pointer;">
          <div v-if="!hasCollection"  v-on:click="collection()"><img src="@/assets/images/jl/jl-sc.png" style="width:14px;margin-top:-2px;margin-right:0px;">
          收藏
          </div>
          <div v-if="hasCollection" v-on:click="delCollection()"><img src="@/assets/images/jl/jl-sc1.png" style="width:14px;margin-top:-2px;margin-right:0px;">
          已收藏
        </div>
      </div>
      </div>
      <div>
        &nbsp;
      </div>
      <div>
        <button style="background-color:#90c31f;border:none;border-radius:5px;padding:5px 5px;color:#fff;width:43.5%;margin-right:2px;" v-on:click="getCvPreview">预览&保存</button>
        <button style="background-color:#f8b62b;border:none;border-radius:5px;padding:5px 5px;color:#fff;width:53.5%" v-on:click="getCvPGBG">简历评估报告</button>
      </div>
    </div>
    <!--简历阅览情况-->
    <div class="card" v-show="currentUserType!='enterprise'">
      <div class="card-header">
        <h2 class="card-title ">活跃度</h2>
      </div>
      <div class="list-group list-group-transparent">
        <div class="list-group-item list-group-item-action d-flex align-items-center">
          <span class="icon mr-3"><i class="icon icon-eye"></i></span>被浏览次数<span class="ml-auto badge badge-default" v-text="active.browseRecordsCount">14</span>
        </div>
        <div class="list-group-item list-group-item-action d-flex align-items-center">
          <span class="icon mr-3"><i class="icon icon-pin"></i></span>收藏企业数<span class="ml-auto badge badge-default" v-text="active.collectionEntCount">14</span>
        </div>
        <div class="list-group-item list-group-item-action d-flex align-items-center">
          <span class="icon mr-3"><i class="fe fe-heart"></i></span>标注“可面试”企业数<span class="ml-auto badge badge-default" v-text="active.interviewableEntCount">14</span>
        </div>
        <div class="list-group-item list-group-item-action d-flex align-items-center">
          <span class="icon mr-3"><i class="fa fa-newspaper-o"></i></span>标注“备选”企业数<span class="ml-auto badge badge-default" v-text="active.alternativeEntCount">14</span>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="border-bottom align-items-center">
          <div class="profile-details">
            <div class="list-group list-group-transparent mb-0 mail-inbox" style="padding-top:10px;">
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==1?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('base-info',1)">
                <span class="icon mr-3"><span class="jl-grxx"></span></span>个人信息
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==2?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('job-intention',2)">
                <span class="icon mr-3"><span class="jl-qzyx"></span></span>求职意向
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==3?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('job-experience',3)">
                <span class="icon mr-3"><span class="jl-gzjl"></span></span>工作经历
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==4?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('edu-experience',4)">
                <span class="icon mr-3"><span class="jl-jyjl"></span></span>教育经历
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==5?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('train-experience',5)" >
                <span class="icon mr-3"><span class="jl-pxjl"></span></span>培训经历
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==6?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('language-competence',6)" >
                <span class="icon mr-3"><span class="jl-yynl"></span></span>语言能力
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==7?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('ext-skill',7)">
                <span class="icon mr-3"><span class="jl-zyjn"></span></span>专业技能
              </a>
            </div>
          </div>
        </div>
    </div>
    <div class="card" style="padding:10px;">
      <div>
        <!-- 证书附件位置 -->
        <div style="line-height:30px;color:#333;">附件（证书证明）：</div>
        <ul v-if="certificateFileIdList.length>0">
          <li class="ml-3" v-for="(value,key,index) in certificateFileIdList"  v-bind:key="key" style="line-height:40px;margin-bottom:3px;margin-left:0px !important;padding-left:10px;padding-right:10px;background-color:#f2f2f2;">
            <span v-if="jobApplyList.length>0 || hasDownload || currentUserType=='personal' || isPrivilegeEnterprise" href="javascript:void(0)" style="cursor: pointer;"  v-on:click="downLoadFile(value.id)">
              <img src="@/assets/images/common-icon-1.png" style="width:20px;margin-right:5px;"><span v-text="value.fileName">附件1.doc</span>
            </span>
            <span v-if="!(jobApplyList.length>0 || hasDownload || currentUserType=='personal' || isPrivilegeEnterprise)"><img src="@/assets/images/common-icon-2.png" style="width:20px;margin-right:5px;"><span v-text="value.fileName">附件1.doc</span></span>
          </li>
        </ul>
        <!-- 附件位置 -->
        <div style="line-height:30px;color:#333;">附件（简历）：</div>
        <ul v-if="cvFileIdList.length>0">
          <li class="ml-3" v-for="(value,key,index) in cvFileIdList"  v-bind:key="key" style="line-height:40px;margin-bottom:3px;margin-left:0px !important;padding-left:10px;padding-right:10px;background-color:#f2f2f2;">
            <span v-if="jobApplyList.length>0 || hasDownload || currentUserType=='personal' || isPrivilegeEnterprise" href="javascript:void(0)" style="cursor: pointer;" v-on:click="downLoadFile(value.id)">
              <img src="@/assets/images/common-icon-1.png" style="width:20px;margin-right:5px;"><span v-text="value.fileName">附件1.doc</span>
            </span>
            <span v-if="!(jobApplyList.length>0 || hasDownload || currentUserType=='personal' || isPrivilegeEnterprise)"><img src="@/assets/images/common-icon-2.png" style="width:20px;margin-right:5px;"><span v-text="value.fileName">附件1.doc</span></span>
          </li>
        </ul>
        <span  v-if="certificateFileIdList.length<=0 && cvFileIdList.length<=0">
          未上传
        </span>
      </div>
    </div>
    <!--简历导航-->
    <!-- <div class="card clearfix">
      <div class="card-header">
        <h2 class="card-title">简历信息</h2>
      </div>
      <div class="card-body p-0">
        <div class="card-body bg-primary text-white">
          <img v-if="headPic.headPicId!=''" :src="'/api/dfs/file/loadPic?id='+headPic.headPicId" class="profile-img img-responsive center-block" width="128px" height="128px" alt="">
          <img v-else src="@/assets/images/faces/user.png" class="profile-img img-responsive center-block" width="128px" height="128px" alt="">
          <div class="profile-stars mt-3" style="text-align: center;" title="简历完善级别">
            <i class="fa fa-star"></i>
            <i class="fa" v-bind:class="[active.startNum<2?(active.startNum>1?'fa-star-half-o':'fa-star-o'):'fa-star']"></i>
            <i class="fa" v-bind:class="[active.startNum<3?(active.startNum>2?'fa-star-half-o':'fa-star-o'):'fa-star']"></i>
            <i class="fa" v-bind:class="[active.startNum<4?(active.startNum>3?'fa-star-half-o':'fa-star-o'):'fa-star']"></i>
            <i class="fa" v-bind:class="[active.startNum<5?(active.startNum>4?'fa-star-half-o':'fa-star-o'):'fa-star']"></i>
          </div>
          <div class="profile-since" style="text-align: center;">
            简历完善度: <span v-text="active.degree"></span>%
          </div>
          <div class="profile-since" style="text-align: center;">
            <img src="@/assets/images/gru_credit.png" class="check-logo" v-if="crtInfo!=null && crtInfo.graduateCheck">
            <img src="@/assets/images/job_cer.png" class="check-logo" v-if="crtInfo!=null && crtInfo.jobCreditCheck">
          </div>

        </div>
        <div class="border-bottom align-items-center">
          <div class="profile-details">
            <div class="list-group list-group-transparent mb-0 mail-inbox">
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==1?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('base-info',1)">
                <span class="icon mr-3"><i class="fe fe-user"></i></span>个人信息
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==2?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('job-intention',2)">
                <span class="icon mr-3"><i class="fe fe-send"></i></span>求职意向
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==3?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('job-experience',3)">
                <span class="icon mr-3"><i class="fe fe-list"></i></span>工作经历
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==4?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('edu-experience',4)">
                <span class="icon mr-3"><i class="icon-graduation"></i></span>教育经历
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==5?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('train-experience',5)" >
                <span class="icon mr-3"><i class="fe fe-book-open"></i></span>培训经历
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==6?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('language-competence',6)" >
                <span class="icon mr-3"><i class="fe fe-star"></i></span>语言能力
              </a>
              <a class="list-group-item list-group-item-action d-flex align-items-center  mb-2" v-bind:class="[viewIndex==7?'active':'']" href="javascript:void(0)" v-on:click="goAnchor('ext-skill',7)">
                <span class="icon mr-3"><i class="fe fe-award"></i></span>专业技能
              </a>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    
  </div>
</template>

<script>
    import {getFileLink, loadPic,getFileList} from "@/api/common";
    import {isEmpty} from "@/api/validator";
    import {getCvActive,getMyCvView,getCvEnum,saveCollection,delCollection} from "@/api/cv";
    import {listUserByIds} from "@/api/user";
    import Toastr from "toastr2";
    import {jobAbilityConsume, getApplyJobInfoByCvId, getJobCache, getUserLabelList} from '@/api/job'
    import Swal from 'sweetalert2'
    export default {
        name: "CvViewBar",
        data() {
            return {
                headPic: {
                    headPicId: ""
                },
                active:{
                    browseRecordsCount:0,
                    collectionEntCount:0,
                    interviewableEntCount:0,
                    alternativeEntCount:0,
                    startNum:1,
                    degree:0
                },
                viewIndex:1,
                crtInfo:{},
                cvFileIdList:[],
                certificateFileIdList:[],
                hasCollection:false,
                jobApplyList:[],
                collectionOpTypeMap:{},
                hasDownload:false
            }
        },
        computed:{
            currentUserType:{
                get: function () {
                    return this.$store.getters.userType
                }
            },
            isPrivilegeEnterprise:{
                get: function () {
                  var curEntId=this.$store.getters.enterpriseInfo.id
                  return curEntId=='d957e097a29b4d54bfea76a145940c43'
                }
            }
        },
        mounted() {
            this.getHeadPicLink();
            this.getCvActive();
            this.getFileLink();
            this.getView();
            this.getApplyJob();
            //获取枚举
            getCvEnum().then(response => {
                //收藏类型
                this.collectionOpTypeMap = response.collectionOpTypeMap;
            }).catch(error => {
            })

        },
        methods: {
            getHeadPicLink(){
                const data={
                    moduleObjectId:this.$route.query.basicId
                };
                getFileLink(data).then(response => {
                    const linkList=response.links;
                    if(linkList!=null&&linkList.length>0){
                        for(let link in linkList){
                            //头像
                            if(linkList[link].uploadType=='1'){
                                this.headPic.headPicId=linkList[link].uploadId;
                            }
                        }
                    }
                })
            },
            getCvActive(){
                getCvActive(this.$route.query.basicId).then(response => {
                    this.active.browseRecordsCount=response.browseRecordsCount;
                    this.active.collectionEntCount=response.collectionEntCount;
                    this.active.interviewableEntCount=response.interviewableEntCount;
                    this.active.alternativeEntCount=response.alternativeEntCount;
                    this.active.startNum=response.startNum;
                    this.active.degree=response.degree;
                    let addUserId=response.addUserId;
                    if(!isEmpty(addUserId)){
                         let ids = []
                         ids.push(addUserId)
                         listUserByIds(ids).then(response1 => {
                            let userInfo = response1.users
                           this.crtInfo= userInfo[addUserId];
                         })
                    }
                })
            },
            goAnchor(selector, index) {
                this.viewIndex = index;
                document.getElementById(selector).scrollIntoView();
            },
            getFileLink(){
                if(!isEmpty(this.$route.query.basicId)){
                    const data={
                        moduleObjectId:this.$route.query.basicId
                    };
                    getFileLink(data).then(response => {
                        const linkList=response.links;
                        if(linkList!=null&&linkList.length>0){
                            let cvfileIdList=[];
                            let certificateFileIdList=[];
                            for(let link in linkList){
                                //附件
                                if(linkList[link].uploadType=='2'){
                                    cvfileIdList.push(linkList[link].uploadId);
                                }
                                if(linkList[link].uploadType=='3'){
                                    certificateFileIdList.push(linkList[link].uploadId);
                                }
                            }
                            if(cvfileIdList.length>0){
                                this.getCvFileList(cvfileIdList);
                            }
                            if(certificateFileIdList.length>0){
                                this.getCertificateFileList(certificateFileIdList);
                            }
                        }
                    })
                }
            },
            getCvFileList(fileIdList){
                //根据ID列表查询文件列表
                getFileList(fileIdList).then(response => {
                    this.cvFileIdList=response.fileList;
                })
            },
            getCertificateFileList(fileIdList){
                //根据ID列表查询文件列表
                getFileList(fileIdList).then(response => {
                    this.certificateFileIdList=response.fileList;
                })
            },
            downLoadFile(uploadId){
                if (!isEmpty(uploadId)) {
                    window.location.href='/api/dfs/file/downInnerFile?id='+uploadId
                }
            },
            getView(){
                //获取简历基本信息
                getMyCvView(this.$route.query.basicId).then(response => {
                    let hasDown = response.hasDownload
                    if(hasDown != null){
                        this.hasDownload = hasDown;
                    }
                    let hasCollection = response.hasCollection
                    if(hasCollection != null){
                      this.hasCollection = hasCollection
                    }
                }).catch(error => {
                })
            },
            getApplyJob(){
                if(this.currentUserType=='enterprise'){
                    getApplyJobInfoByCvId(this.$route.query.basicId).then(response => {
                        this.jobApplyList = response.jobApplyList;
                    })
                }
            },
          getCvPreview(){
              this.$router.push({
                  path: `/cv/cv_preview`,
                  query: {basicId: this.$route.query.basicId}
              })
          },
          getCvPGBG(){
              this.$router.push({
                  path: `/cv/no_permission`,
                  // query: {basicId: this.$route.query.basicId}
              })
          },
          //收藏
            collection() {
                const that=this;
                Swal.fire({
                    title: '请选择收藏类别',
                    type: 'question',
                    input: 'radio',
                    inputOptions: this.collectionOpTypeMap,
                    inputValue:'2',
                    showCancelButton: true,
                    allowOutsideClick :false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator: function(value) {
                        if(!isEmpty(value)){
                            return new Promise(function(resolve) {
                                resolve();
                            });
                        }
                    }
                }).then(function(result) {
                    if (!isEmpty(result.value)) {
                        const collection={
                            basicId:that.$route.query.basicId,
                            opType:result.value
                        };
                        saveCollection(collection).then(response => {
                            const toast = new Toastr()
                            toast.success('收藏成功');
                            //重新加载数据
                            that.getView();
                        }).catch(error => {

                        })
                    }
                })

            },
            //取消收藏
            delCollection() {
                const that=this;
                Swal.fire({
                    title: '您确定取消收藏么?',
                    // text: "删除后无法恢复!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#9ac043',
                    // cancelButtonColor: '#d33',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(function(isConfirm) {
                    if (isConfirm.value) {
                        const toast = new Toastr()
                        delCollection(that.$route.query.basicId).then(response => {
                            toast.success('取消成功');
                            //重新加载数据
                            that.getView();
                        }).catch(error => {

                        })
                    }
                });
            },
        }
    }
</script>

<style >
  .check-logo{
    width: 90px;
  }
   .list-group-transparent .list-group-item.active{
    color: #90c31f;
   }
  .list-group-transparent .active::before{
    content: "|";
    color: #90c31f;
    position: absolute;
    left: -1px;
    font-size: 18px;
    top: 5px;
  }
  .jl-grxx{
    background-image: url("../../assets/images/jl/jl-grxx.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }
  .list-group-transparent .active .jl-grxx{
    background-image: url("../../assets/images/jl/jl-grxx1.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }

  .jl-qzyx{
    background-image: url("../../assets/images/jl/jl-qzyx.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }
  .list-group-transparent .active .jl-qzyx{
    background-image: url("../../assets/images/jl/jl-qzyx1.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }

  .jl-gzjl{
    background-image: url("../../assets/images/jl/jl-gzjl.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }
  .list-group-transparent .active .jl-gzjl{
    background-image: url("../../assets/images/jl/jl-gzjl1.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }

  .jl-jyjl{
    background-image: url("../../assets/images/jl/jl-jyjl.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }
  .list-group-transparent .active .jl-jyjl{
    background-image: url("../../assets/images/jl/jl-jyjl1.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }

  .jl-pxjl{
    background-image: url("../../assets/images/jl/jl-pxjl.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }
  .list-group-transparent .active .jl-pxjl{
    background-image: url("../../assets/images/jl/jl-pxjl1.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }

  .jl-yynl{
    background-image: url("../../assets/images/jl/jl-yynl.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }
  .list-group-transparent .active .jl-yynl{
    background-image: url("../../assets/images/jl/jl-yynl1.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }

  .jl-zyjn{
    background-image: url("../../assets/images/jl/jl-zyjn.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }
  .list-group-transparent .active .jl-zyjn{
    background-image: url("../../assets/images/jl/jl-zyjn1.png");
    background-size: 100% 100%;
    display: block;
    width: 15px;
    height: 15px;
  }

  .jl-sc{
    background-image: url("../../assets/images/jl/jl-sc.png");
    background-size: 100% 100%;
    /* display: inline-block; */
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
  .jl-sc1{
    background-image: url("../../assets/images/jl/jl-sc1.png");
    background-size: 100% 100%;
    /* display: inline-block; */
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cv/CvViewBar.vue